// Reusable star-rating pieces used across the astrologer reviews module —
// an interactive input for the review form and a read-only display for
// cards/summaries. Text-glyph stars ('★'/'☆') match the visual language
// AstrologerReviewsSection already used before this module existed.

const SIZE_CLASSES = {
  sm: 'text-xs',
  md: 'text-base',
  lg: 'text-2xl',
}

/** Clickable 1–5 star input, keyboard accessible via real <button>s. */
export function StarRatingInput({ value = 0, onChange, size = 'lg', disabled = false }) {
  return (
    <div className="flex items-center gap-1" role="radiogroup" aria-label="Rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          role="radio"
          aria-checked={value === star}
          aria-label={`${star} star${star > 1 ? 's' : ''}`}
          disabled={disabled}
          onClick={() => onChange?.(star)}
          className={`${SIZE_CLASSES[size]} leading-none transition-transform hover:scale-110 disabled:cursor-not-allowed disabled:opacity-50`}
          style={{ color: star <= value ? '#C8922A' : '#D7C29A' }}
        >
          {star <= value ? '★' : '☆'}
        </button>
      ))}
    </div>
  )
}

/** Read-only stars, rounded to the nearest whole star. */
export function StarRatingDisplay({ value = 0, size = 'md', showValue = false }) {
  const rounded = Math.round(Number(value) || 0)
  return (
    <span className={`inline-flex items-center gap-1.5 ${SIZE_CLASSES[size]}`}>
      <span className="tracking-tight" style={{ color: '#C8922A' }}>
        {'★'.repeat(Math.max(0, Math.min(5, rounded)))}
        {'☆'.repeat(5 - Math.max(0, Math.min(5, rounded)))}
      </span>
      {showValue && Number(value) > 0 && (
        <span className="text-[#8B7355] font-semibold text-xs">{Number(value).toFixed(1)}</span>
      )}
    </span>
  )
}
